export const SURVEY_PROGRESS_STATUS = {
  NOT_STARTED: 'not-started',
  STARTED: 'started',
  FINISHED: 'finished'
};



// WEBPACK FOOTER //
// /dist/src/app/survey/fill-out-the-questionnaire/survey-progress-status.const.ts